import type { ListContext } from '@/lib/eventBus/trackingEvents'
import type { GTMItemList } from '@/types/gtm'

const NO_ITEM_LIST: GTMItemList = { item_list_id: null, item_list_name: null }

/** GA4 report names for each product list. Analysts own these names, so a rename changes only this file. */
export const toGA4ItemList = (listContext?: ListContext): GTMItemList => {
  if (!listContext) {
    return NO_ITEM_LIST
  }

  switch (listContext.kind) {
    case 'search':
      return { item_list_id: `Search '${listContext.searchTerm}'`, item_list_name: 'Search List' }
    case 'catalogue':
      return { item_list_id: 'catalogue_list', item_list_name: 'Catalogue List' }
    case 'contractedProducts':
      return { item_list_id: 'contracted_products', item_list_name: 'Contracted Products' }
    case 'relatedProducts':
      return { item_list_id: 'related_products', item_list_name: 'Related Products' }
    case 'accessoryProducts':
      return { item_list_id: 'accessory_products', item_list_name: 'Accessory Products' }
    case 'upsellingProducts':
      return { item_list_id: 'upselling_products', item_list_name: 'Upselling Products' }
    case 'favoriteList':
      return { item_list_id: `favorite_list_${listContext.favoriteListName}`, item_list_name: 'Favorite List' }
    case 'productRecommendations':
      return { item_list_id: listContext.sanityComponentId, item_list_name: 'Product Recommendations' }
    case 'productDetails':
      return { item_list_id: 'product_details', item_list_name: 'Product Details' }
    case 'positiveList':
      return { item_list_id: null, item_list_name: 'Positive List' }
    case 'appropriations':
      return { item_list_id: null, item_list_name: 'Appropriations' }
    case 'cart':
      return { item_list_id: null, item_list_name: 'Cart' }
  }
}
